import React from "react";

const CheckmarkIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 14"
      width="16"
      height="15"
      fill="#a3d9cb"
    >
      <path d="M4.7 10.6L13 .4s.7-.9 1.6-.1c.8.7.1 1.6.1 1.6L4.9 14 .4 9.4s-.8-.7 0-1.6c.8-.8 1.6 0 1.6 0l2.7 2.8z" />
    </svg>
  );
};

export default CheckmarkIcon;
